const TABLE_TOP_WIDTH = 2;
const TABLE_TOP_LENGTH = 5;
const TABLE_TOP_THICKNESS = 0.3;
const TABLE_TOP_SURFACE_Y = 1.5;
const TABLE_TOP_CENTER_Y = TABLE_TOP_SURFACE_Y - TABLE_TOP_THICKNESS / 2;
const LEG_THICKNESS = 0.28;
const LEG_HEIGHT = TABLE_TOP_SURFACE_Y - TABLE_TOP_THICKNESS;
const LEG_CENTER_Y = LEG_HEIGHT / 2;
const HALF_W = TABLE_TOP_WIDTH / 2;
const HALF_L = TABLE_TOP_LENGTH / 2;
const LEG_OFFSET_X = HALF_W - LEG_THICKNESS;
const LEG_OFFSET_Z = HALF_L - LEG_THICKNESS;

export default function Table({ position }: { position: [number, number, number] }) {
	return (
		<group position={position}>
			<mesh position={[0, TABLE_TOP_CENTER_Y, 0]} castShadow receiveShadow>
				<boxGeometry args={[TABLE_TOP_WIDTH, TABLE_TOP_THICKNESS, TABLE_TOP_LENGTH]} />
				<meshStandardMaterial color="white" />
			</mesh>
			{[ [-LEG_OFFSET_X, -LEG_OFFSET_Z], [LEG_OFFSET_X, -LEG_OFFSET_Z], [-LEG_OFFSET_X, LEG_OFFSET_Z], [LEG_OFFSET_X, LEG_OFFSET_Z] ].map(([x, z], i) => (
				<mesh key={i} position={[x, LEG_CENTER_Y, z]} castShadow receiveShadow>
					<boxGeometry args={[LEG_THICKNESS, LEG_HEIGHT, LEG_THICKNESS]} />
					<meshStandardMaterial color="white" />
				</mesh>
			))}
		</group>
	);
}